<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full">
         <div class="mt-4">
          <label class="vs-input--label">Status</label>
          <v-select v-model="status_local" :clearable="false" :options="statusOptions" v-validate="'required'" max-width="50" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>        
      </div>
   <!--    <div class="mt-4">
          <label class="vs-input--label">Verified</label>
          <v-select v-model="verified_local" :clearable="false" :options="verifiedOptions" v-validate="'required'" name="verified" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has(true)">{{ errors.first(true) }}</span>
        </div>
 -->
      <!-- <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Role</label>
          <v-select v-model="role_local" :clearable="false" :options="roleOptions" v-validate="'required'" name="role" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('role')">{{ errors.first('role') }}</span>
        </div>

      </div> -->
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="item-content">
          <!-- Item Main Info -->
          <div class="product-details p-6">
            <div class="vx-row mt-6">
              <div class="vx-col md-5 w-full flex items-center justify-center">
                <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0">
                  <img :src="data_local.imageURL" class="responsive">

                  <!--
                    UnComment Below line for true flow
                    <img :src="item_data.image" :alt="item_data.name" class="responsive">

                    Remove above img tag which is for demo purpose in actual flow
                  -->
                </div>
              </div>

              <!-- Item Content -->
              <div class="vx-col md-5 w-full">
    <!-- {{data_local}} -->

                <h3>{{data_local.title}}</h3>

                <p class="my-2">
                  <span class="mr-2">by</span>
                  <span>{{data_local.userInfo.name}}</span>
                </p>
                <p class="my-2">
                  <span class="mr-2">Posted on</span>
                  <span v-if="data_local.createdAt">{{data_local.createdAt.substr(0,10)}}</span>
                </p>
                <p class="flex items-center flex-wrap">
                  <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">{{data_local.status}}</span>
                </p>

                <vs-divider />

                <!-- <p>Lorem lipisipi title descriptions</p> -->
                <div v-html="data_local.description"></div>

                <vs-list class="product-sales-meta-list px-0 pt-4">
                  <vs-list-item class="p-0 border-none" title="Category" icon-pack="feather" icon="icon-bookmark"></vs-list-item>
                  <vs-list-item
                    class="p-0 border-none"
                    title="Tag"
                    icon-pack="feather"
                    icon="icon-tag" />
                </vs-list>
                <vs-divider />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>  


    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      item_data: null,
      data_local: JSON.parse(JSON.stringify(this.data)),
      error_occured: false,
      error_msg: '',

      statusOptions: [
        { label: 'Under Review', value: 'Under Review' },
        { label: 'Open',  value: 'Open' },
        { label: 'Closed',  value: 'Closed' },
        { label: 'Marked As Duplicated',  value: 'Marked As Duplicated' }
      ]
      /*  verifiedOptions: [
        { label: 'Verified',  value: true },
        { label: 'Not Verified',  value: false }
      ], */
      // roleOptions: [
      //   { label: 'Admin',  value: 'admin' },
      //   { label: 'User',  value: 'user' },
      //   { label: 'Staff',  value: 'staff' }
      // ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.data_local.status,  value: this.data_local.status  }
        // return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.data_local.role,  value: this.data_local.role  }
        // return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    /* verified_local: {
      get () {
        return { label: this.capitalize(this.data_local.verified),  value: this.data_local.verified  }
      },
      set (obj) {
        this.data_local.verified = obj.value
      }
    }, */
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    capitalize (str) {
      return str.toUpperCase()
      // return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      var blog = {
        id: this.data_local.id,
        status: this.data_local.status
      }
      this.$store.dispatch('blogs/updateBlog', blog)
        .then(response => {
          this.$vs.notify({
            title: 'Updated',
            text: response.data.data,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          // console.log("blog id ic coming", blog.id)
          // this.$store.dispatch('blogs/fetchBlogs')
        })
        .catch(err => {
          this.$vs.notify({
            title: 'Failed',
            text: err,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          console.log(err)
        })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    }  
  }
}
</script>
